import { render, staticRenderFns } from "./AnalysesTabs.vue?vue&type=template&id=94147972&scoped=true&"
import script from "./AnalysesTabs.vue?vue&type=script&lang=ts&"
export * from "./AnalysesTabs.vue?vue&type=script&lang=ts&"
import style0 from "./analyses-tabs.scss?vue&type=style&index=0&id=94147972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94147972",
  null
  
)

export default component.exports